function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import ButtonComponent from "components/core/new-button/button-component";
import { buttonStyles } from "segments/button-service";
import { REGULAR_BUTTON_CLICKED } from "/constants/bigbrain-event-types";
import classnames from "classnames";
import { DODGER_BLUE_COLOR_NAME, SPACE_BLUE_COLOR_NAME, WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";
import { withAbTests } from "contexts/ab-tests-context";
import { MONDAY_AUTH_DOMAIN } from "constants/links";
import { withGenericConfig } from "/contexts/generic-config-context";
import { getLastPartOfUrl } from "utils/url";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
import { trackEvent } from "/services/bigbrain-service";
import { StyledRegularButton } from "./regular-button.scss";
import DefaultProps from "./default-props";
const isSeoFriendlyUrl = (url)=>{
    let res = false;
    if (url && url.indexOf(MONDAY_AUTH_DOMAIN) < 0) {
        res = true;
    }
    return res;
};
class RegularButton extends PureComponent {
    render() {
        const { buttonSize, color, outline, isWithArrow, iconRenderer, minPadding, url, isOpenLinkInNewTab, additionalText, additionalTextPosition, additionalTextMaxWidth, className } = this.props;
        const buttonStyle = buttonStyles[color] || {};
        const { textColor, backgroundColorName } = buttonStyle;
        const buttonColor = this.getButtonBackgroundColor(backgroundColorName);
        const buttonStrippedText = this.getButtonStrippedText();
        return /*#__PURE__*/ _jsxs(StyledRegularButton, {
            className: classnames("regular-button", buttonSize, additionalText && `additional-text additional-text-${additionalTextPosition}`),
            children: [
                /*#__PURE__*/ _jsx(ButtonComponent, {
                    seoFriendlyUrl: this.isSeoFriendlyUrl && url,
                    isOpenLinkInNewTab: isOpenLinkInNewTab,
                    size: buttonSize,
                    onClick: this.onClick,
                    color: buttonColor,
                    textColor: textColor,
                    outline: outline,
                    isWithArrow: isWithArrow,
                    className: className,
                    iconRenderer: iconRenderer,
                    minPadding: minPadding,
                    children: buttonStrippedText
                }),
                additionalText && /*#__PURE__*/ _jsx("div", {
                    className: classnames("additional-button-text", this.additionalTextPosition),
                    style: {
                        maxWidth: additionalTextMaxWidth
                    },
                    children: /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                        text: additionalText
                    })
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "onClick", (e)=>{
            const { buttonText, url, isOpenLinkInNewTab, onClick, extraEventData } = this.props;
            const isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            trackEvent(REGULAR_BUTTON_CLICKED, {
                kind: buttonText,
                info1: isKeyboardEvent ? "keyboard" : "mouse",
                info2: url,
                info3: getLastPartOfUrl(url),
                data: extraEventData
            });
            if (onClick) {
                onClick(e);
            }
            if (url && !this.isSeoFriendlyUrl) {
                if (isOpenLinkInNewTab) {
                    window.open(url);
                } else {
                    window.location.href = url;
                }
            }
        });
        _define_property(this, "getButtonBackgroundColor", (color)=>{
            if (color === DODGER_BLUE_COLOR_NAME || color === SPACE_BLUE_COLOR_NAME) {
                return WORK_OS_IRIS_COLOR_NAME;
            }
            return color;
        });
        _define_property(this, "getButtonStrippedText", ()=>{
            const { buttonText } = this.props;
            const disallowedButtonChars = [
                /\s*>/g
            ];
            let strippedButtonText = buttonText;
            disallowedButtonChars.forEach((ending)=>{
                strippedButtonText = strippedButtonText.replace(ending, "");
            });
            return strippedButtonText;
        });
        this.isSeoFriendlyUrl = isSeoFriendlyUrl(props.url);
    }
}
RegularButton.defaultProps = DefaultProps;
export default withGenericConfig(withAbTests(RegularButton));
